import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { palette, fontFamily } from '../../styles/tokens';
import { portalShadow } from '../CrewPortal/portalStyles';

export function ConnectCompletePage() {
  const [searchParams] = useSearchParams();
  const businessId = searchParams.get('business_id');

  const [mode] = useState<'popup' | 'fullpage'>(() =>
    typeof window !== 'undefined' && window.opener && !window.opener.closed ? 'popup' : 'fullpage',
  );

  useEffect(() => {
    document.title = "You're all set — CrewBit";
    let meta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
    }
    meta.content = 'noindex, nofollow';
  }, []);

  useEffect(() => {
    if (mode !== 'popup') return;
    try {
      const channel = new BroadcastChannel('stripe-connect');
      channel.postMessage({ type: 'complete', business_id: businessId });
      channel.close();
    } catch {
      // BroadcastChannel unsupported in very old browsers — opener refreshes on next status poll.
    }
    const closeTimer = window.setTimeout(() => {
      try { window.close(); } catch { /* popup-close permission varies by browser */ }
    }, 500);
    return () => window.clearTimeout(closeTimer);
  }, [mode, businessId]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: palette.bg, fontFamily, padding: 24,
    }}>
      <div style={{
        background: palette.white, borderRadius: 16, boxShadow: portalShadow.card,
        padding: '40px 32px', maxWidth: 420, width: '100%', textAlign: 'center',
        border: `1px solid ${palette.g150}`,
      }}>
        <div style={{
          width: 44, height: 44, borderRadius: 12, margin: '0 auto 20px',
          background: `linear-gradient(135deg, ${palette.accent}, ${palette.accentDeep})`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="white" aria-hidden="true">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
          </svg>
        </div>

        <div style={{
          width: 56, height: 56, borderRadius: '50%', margin: '0 auto 16px',
          background: palette.greenWash, display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg
            width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={palette.green}
            strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h1 style={{ fontSize: 22, fontWeight: 700, color: palette.g800, margin: '0 0 8px', fontFamily }}>
          You're all set
        </h1>
        <p style={{ fontSize: 15, color: palette.g500, margin: '0 0 24px', lineHeight: 1.5 }}>
          Payments are live. You can now accept credit cards on invoices and bookings.
        </p>

        {mode === 'fullpage' ? (
          <button
            type="button"
            onClick={() => window.location.replace('/today')}
            style={{
              display: 'inline-block', padding: '12px 28px', borderRadius: 10,
              background: palette.accent, color: palette.white,
              fontSize: 15, fontWeight: 600, border: 'none', cursor: 'pointer', fontFamily,
            }}
          >
            Return to CrewBit
          </button>
        ) : (
          <p style={{ fontSize: 13, color: palette.g400, margin: 0 }}>
            This window will close automatically.
          </p>
        )}
      </div>
    </div>
  );
}
